<script lang="ts">
    import { getContext } from 'svelte';
    import ActionButton from '../ActionButton.svelte';
    import translations from 'Assets/i18n';
    import type DependencyContainer from 'Lib/DependencyContainer';
    import { applicationContextKey } from 'PublicationDependencies';
    import PublicationListService from 'Pages/PublicationPage/Lib/Services/PublicationListService';
    import NotificationService from 'Lib/Services/NotificationService';

    export let scenarioId: string;
    export let fileName: string;
    export let replaceable: boolean;
    export let restoreable: boolean;

    const translationContext = translations.pages.publication.presentationListView;
    const applicationContext = getContext<DependencyContainer>(applicationContextKey);

    const publicationListService = applicationContext.get(PublicationListService);
    const notificationService = applicationContext.get(NotificationService);

    let fileInput: HTMLInputElement;
    let files: FileList | undefined;
    $: if (files) {
        publicationListService.replaceFileAsync(scenarioId, fileName, files.item(0)).then(
            () => {
                restoreable = true;
                notificationService.success(translationContext.fileReplacedSuccessfullyNotification);
            },
            () => {
                notificationService.error(translationContext.fileReplacementFailedNotification);
            },
        );
    }

    async function replaceFile(e: PointerEvent) {
        e.preventDefault();
        const isInUse = await publicationListService.isInUse(scenarioId);

        if (isInUse) {
            notificationService.error(translationContext.isInUseNotification);
            return;
        }

        fileInput?.click();
    }

    async function restoreFile(e: PointerEvent) {
        e.preventDefault();
        const isInUse = await publicationListService.isInUse(scenarioId);

        if (isInUse) {
            notificationService.error(translationContext.isInUseNotification);
            return;
        }

        await publicationListService.restoreFileAsync(scenarioId, fileName).then(
            () => {
                restoreable = false;
                notificationService.success(translationContext.fileRestoredSuccessfullyNotification);
            },
            () => {
                notificationService.error(translationContext.fileRestorationFailedNotification);
            },
        );
    }
</script>

<p>
    {fileName}
    {#if fileName.endsWith('.csv')}
        {#if replaceable}
            <ActionButton
                tooltipContent={translationContext.replaceItemAction}
                disabled={false}
                on:click={replaceFile}>
                <span class="mdi mdi-upload-outline" ></span>
            </ActionButton>
            <input
                accept=".csv"
                type="file"
                bind:files
                bind:this={fileInput} />
        {/if}
        {#if restoreable}
            <ActionButton
                tooltipContent={translationContext.restoreItemAction}
                disabled={false}
                on:click={restoreFile}>
                <span class="mdi mdi-file-restore-outline" ></span>
            </ActionButton>
        {/if}
    {/if}
</p>

<style>
    .mdi {
        font-size: 16px;
        color: #0078d7;
        vertical-align: middle;
    }

    input {
        display: none;
    }
</style>
